import { Component } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../components/ui.module';
import { BranchShrinkData } from '../../../types';

type CellParams = ICellRendererParams<BranchShrinkData> & {
  addCallback: (item: BranchShrinkData) => void;
};

@Component({
  selector: 'app-pan-manage-shrink-list-header-actions',
  imports: [UiModule, MatTooltipModule, RouterModule],
  templateUrl: './manage-shrink-list-header-actions.component.html',
  styleUrl: './manage-shrink-list-header-actions.component.scss',
})
export class ManageShrinkListHeaderActionsComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
